/**
 * @generated SignedSource<<183b0f4f70a619b8ce64abb62a2411dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArtistDirectoryCards_allArtists$data = {
  readonly allArtists: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ArtistDirectoryCard_artist">;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "ArtistDirectoryCards_allArtists";
};
export type ArtistDirectoryCards_allArtists$key = {
  readonly " $data"?: ArtistDirectoryCards_allArtists$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArtistDirectoryCards_allArtists">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "allArtists"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 6,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "displayName_Icontains"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "genres"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "instagramFollowers"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "onlyWatching"
    },
    {
      "defaultValue": "growth_score_desc",
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "partnershipStatuses"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "seekingServices"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "spotifyMonthlyListeners"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "streamsThisWeek"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tiktokFollowers"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tiktokPosts"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ArtistListPaginationQuery.graphql')
    }
  },
  "name": "ArtistDirectoryCards_allArtists",
  "selections": [
    {
      "alias": "allArtists",
      "args": [
        {
          "kind": "Variable",
          "name": "displayName_Icontains",
          "variableName": "displayName_Icontains"
        },
        {
          "kind": "Variable",
          "name": "genres",
          "variableName": "genres"
        },
        {
          "kind": "Variable",
          "name": "instagramFollowers",
          "variableName": "instagramFollowers"
        },
        {
          "kind": "Variable",
          "name": "onlyWatching",
          "variableName": "onlyWatching"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "partnershipStatuses",
          "variableName": "partnershipStatuses"
        },
        {
          "kind": "Variable",
          "name": "seekingServices",
          "variableName": "seekingServices"
        },
        {
          "kind": "Variable",
          "name": "spotifyMonthlyListeners",
          "variableName": "spotifyMonthlyListeners"
        },
        {
          "kind": "Variable",
          "name": "streamsThisWeek",
          "variableName": "streamsThisWeek"
        },
        {
          "kind": "Variable",
          "name": "tiktokFollowers",
          "variableName": "tiktokFollowers"
        },
        {
          "kind": "Variable",
          "name": "tiktokPosts",
          "variableName": "tiktokPosts"
        }
      ],
      "concreteType": "ArtistNodeConnection",
      "kind": "LinkedField",
      "name": "__ArtistList_allArtists_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArtistNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArtistNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ArtistDirectoryCard_artist"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "2348457389637bacd4de1f5105efd91c";

export default node;
